export const LANGUAGE_TRANSLATOR_DROPDOWN_ID = "language-translator";
export const DROPDOWN_ID = "country-language-dropdown";
